// extracted by mini-css-extract-plugin
module.exports = {"slickSlide":"small-slider_slickSlide__2qQ4b"};